import { InputText } from "primereact/inputtext";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { syntageCss } from "./Syntage.css";
import { Button } from "primereact/button";
import {
  buroPersonaF,
  buroPersonaFE,
  buroPersonaM,
} from "../../../../../Assets/Images";
import { Controller, set, useForm } from "react-hook-form";
import { estados } from "../../../../../Utils";
import { Dropdown } from "primereact/dropdown";
import { CustomDateInput } from "../CustomDateInput/CustomDateInput";
import axios from "axios";
import { Loader } from "../../../../../Components";
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { AuthContext } from "../../../../../Context/AuthContext";
import { useLocation, useParams } from "react-router-dom";
import { Checkbox } from 'primereact/checkbox';
import { api, url } from "../../../../../env";


function Syntage({ setPage, state, userData, setUserData, setPageStep3, setStep, pageStep3 }) {

  const { authInfo } = useContext(AuthContext);

  const [showPassword, setShowPassword] = useState(false);

  const { secret } = useParams()

  const { search } = useLocation();
  const params = new URLSearchParams(search);
  let id = params.get("id");

  // console.log(authInfo, "authInfoauthInfo", secret);

  const defaultValues = {
    rfc: pageStep3.infoUser ? pageStep3.infoUser?.rfc : null,
    password: null,
    confirmPassword: null,
    confirmRfc: null,
    checkConfirm: false,
  };

  const {
    register,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
    control,
    setValue,
  } = useForm({ defaultValues });

  const [isErrorFetching, setIsErrorFetching] = useState(false);
  const [isValidCredentials, setIsValidCredentials] = useState(null);
  const [uuid, setUuid] = useState(null);
  const [retryCount, setRetryCount] = useState(0);
  const [message, setMessage] = useState(false);
  const [loading, setLoading] = useState(false);

  const checkUserValidSyntage = (id) => {
    axios
      .get(`${url}/fecthSyntage/credentials/${id}`)
      .then((res) => {
        if (res.data.status_credentials === "pending") {
          if (retryCount < 2) {
            setRetryCount(retryCount + 1);
          } else {
            setIsErrorFetching(true);
            setLoading(false);
            setMessage("Error al validar, intente de nuevo ");
            return;
          }
        } else {
          //reseteamos intentos por si hay otra peticion
          setRetryCount(0);
          setLoading(false);

          // en caso de que sea otro status diferente de valid
          if (res.data.status_credentials !== "valid") {
            setIsErrorFetching(true);
            setMessage("Error al validar credenciales");
            return;
          }
          setLoading(false);
          setIsValidCredentials(true);
          setPage(4);
          // setStep(4)
          // continuar con flujo normal CREDENCIALES CORRECTAS
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const timerCheckCredentials = () => {
    setLoading(true);
    return setTimeout(() => {
      checkUserValidSyntage(uuid);
    }, 8000);
  }

  useEffect(() => {
    // if(retryCount == 3) {
    //   setRetryCount(0);
    // }
    if (uuid === null || retryCount == 3 || isValidCredentials) return;

    const timer = timerCheckCredentials();

    return () => clearInterval(timer);

  }, [retryCount]);

  const submit = (data) => {


    // si se vuelve hacer la misma peticion se hara con el mismo uuid
    if (!isValidCredentials && uuid) return timerCheckCredentials();

    let rfc = data.rfc;
    let password = data.password;
    setIsErrorFetching(false);
    setLoading(true);
    axios
      .post(`${url}/fecthSyntage/credentials`, {
        rfc,
        password,
        email: authInfo.user.email,
        secret, id
      })
      .then((res) => {
        // syntage solo regresa estos status de error
        if (res.data[0] !== 400 && res.data[0] !== 401) {
          setIsErrorFetching(false);
          setIsValidCredentials(false);

          setTimeout(() => {
            setUuid(res.data[1].id);
            // checar si fueron validas estas credenciales
            checkUserValidSyntage(res.data[1].id);
          }, 5000);
        } else {
          setIsErrorFetching(true);
          setMessage("Rfc o contraseña incorrectos");
          setLoading(false);
        }
      })
      .catch((err) => {
        setIsErrorFetching(true);
        setLoading(false);
        setMessage("Rfc o contraseña incorrectos");
      });
  };

  const handleTogglePassword = () => {
    setShowPassword(!showPassword);
  };

  // Reset form with default values when component mounts
  useEffect(() => {
    reset(defaultValues);
  }, [reset, pageStep3]); // Se vuelve a resetear si `pageStep3` cambia



  return (
    <div css={syntageCss()}>
      {loading &&
        <div style={{
          zIndex: 1000,
        }}>
          <Loader msg="Este paso puede tardar unos minutos, por favor no cierres la ventana." />
        </div>
      }
      <div className="Background" />

      <Button
        label="Regresar"
        className="Green py-3"
        // onClick={() => setPageStep3(0)}
        onClick={() => setPageStep3(prev => ({
          ...prev,
          selectedMethod: 0
        }))}
      />
      <div className="TopText">Ahora vamos a revisar tu Buró de Crédito.</div>
      <div className="TopText2 pb-6">
        <span>
          Por favor, ingresa tu rfc y contraseña que utilizas para ingresar al
          sat
        </span>
      </div>

      <div className="flex flex-column align-items-center FormContainer">
        <form className="grid" onSubmit={handleSubmit((data) => submit(data))}>
          <div className="col-12 p-2">
            <InputText
              // tooltip={errors["email"] ? 'Ingrese un correo válido' : null}
              // tooltipOptions={{ event: 'focus', position: 'top' }}
              maxLength={13}
              {...register("rfc", {
                required: true,
                pattern: /^[A-Za-z0-9]{12,13}$/, // Patrón para permitir solo letras y números y de longitud 12 a 13
                maxLength: 13,
              })}
              placeholder="RFC"
              className={
                "EmailInput w-full TextInput " +
                `${errors["rfc"] ? "p-invalid" : ""}`
              }
            />
          </div>

          <div className="col-12 p-2">
            <InputText
              maxLength={13}
              {...register("confirmRfc", {
                required: true,
                pattern: /^[A-Za-z0-9]{12,13}$/, // Patrón para permitir solo letras y números y de longitud 12 a 13
                maxLength: 13,
                validate: (value) => value === watch("rfc"),
              })}
              placeholder="Confirma tu RFC"
              className={
                "EmailInput w-full TextInput " +
                `${errors["confirmRfc"] ? "p-invalid" : ""}`
              }
            />
          </div>

          <IconField iconPosition="right" className="w-full relative">
            <div className="col-12 p-2">
              <InputText
                maxLength={40}
                {...register("password", {
                  required: true,
                  // pattern: /^(([^<>()\[\]\\.,;:\s@”]+(\.[^<>()\[\]\\.,;:\s@”]+)*)|(“.+”))@((\[[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}\.[0–9]{1,3}])|(([a-zA-Z\-0–9]+\.)+[a-zA-Z\s]{2,}))$/,
                  maxLength: 40,
                })}
                type={showPassword ? "text" : "password"}
                placeholder="Contraseña SAT"
                className={
                  "EmailInput w-full TextInput " +
                  `${errors["paswword"] ? "p-invalid" : ""}`
                }
              />
            </div>
            <InputIcon onClick={handleTogglePassword} style={{
              zIndex: "100", marginBottom: "1em", top: "1.5em",
              right: "1.8em"
            }} className={showPassword ? "pi pi-eye-slash pointer eyePassMobile" : "pi pi-eye pointer eyePassMobile"} >
            </InputIcon>
          </IconField>

          <div className="col-12 p-2">
            <InputText
              maxLength={40}
              {...register("confirmPassword", {
                required: true,
                maxLength: 40,
                validate: (value) => value === watch("password"),
              })}
              type="password"
              placeholder="Confirma tu Contraseña SAT"
              className={
                "EmailInput w-full TextInput " +
                `${errors["confirmPassword"] ? "p-invalid" : ""}`
              }
            />
          </div>

          <div className="col-12 p-2">
            <Controller
              name="checkboxField"
              control={control}
              defaultValue={false}
              rules={{ required: 'Debes aceptar los términos y condiciones' }}
              render={({ field }) => (
                <Checkbox
                  inputId="checkboxField"
                  onChange={(e) => field.onChange(e.target.checked)}
                  checked={field.value}
                  invalid={errors["checkboxField"]}
                  style={{ color: "#29588c", borderColor: "#29588c" }}
                />
              )}
            />
            <label htmlFor="checkboxField" style={{ paddingLeft: ".5rem" }}>Acepto términos y condiciones</label>
          </div>

          {/* <div className="col-12 p-2">
            <Controller
              name="checkboxField"
              control={control}
              defaultValue={false}
              render={({ field }) => <input type="checkbox" {...field} />}
            />
            Acepto terminos y condiciones
          </div> */}

          {/* <div className="grid">
            <div className="col CheckboxRow">
              <input type="checkbox" />
              <span className='BlackText'>Declaración de veracidad de información</span>
            </div>
          </div> */}

          <div className="grid">
            <div className="col Paragraph">
              <span className='Disclaimer'>
                Autorizo expresamente a CONDUCE CAPITAL SAPI DE CV., para llevar a cabo investigaciones sobre mi comportamiento crediticio en las sociedades de información crediticia (SIC) que estime conveniente.
                Conozco la naturaleza y alcance de la información que se solicitará, del uso se le dará y que se podrán realizar consultas periódicas de mi historial crediticio. Consiento que esta autorización tenga una vigencia de 3 años contados a partir de hoy, y en su caso mientras mantengamos relación jurídica. Acepto que este documento queda bajo propiedad de CONDUCE CAPITAL SAPI DE CV. para efectos de control y cumplimiento del artículo 28 de la LRSIC.
              </span>
            </div>
          </div>

          <div className="Container">
            {isErrorFetching && (
              <div className="ErrorMessage">
                <span className="ErrorText"> {message}</span>
              </div>
            )}
          </div>

          <div className={`col-12 p-2 ButtonContainer `}>
            <Button
              label="Continuar"
              className="w-full Green Button py-3"
              onClick={() => {
                setRetryCount(0);
                setIsErrorFetching(false);
                // setLoading(true);
                // setUuid(null);
                setIsValidCredentials(null);
              }}
              type="submit"
            />

          </div>
          <div className="col-12 flex justify-content-center pt-6">
            <div
              className="shadowCard "
              style={{ height: "2rem", width: "80%" }}
            />
          </div>
        </form>
      </div>
    </div>
  );
}

export { Syntage };
